import { useState, useEffect, useCallback } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Terms.scss";
import { NotificationManager } from "react-notifications";
import { getPageContent } from "../../api/apiRequest";
import { useLangContext } from "../../context/languageContext";

const Terms = () => {

  const {hostLanguage} = useLangContext();
  const [contentDetails,setContentDetails] = useState();


  // get page content
  const getAllPageContent = useCallback( async() => {
    try
    {
      let apiRes = await  getPageContent(hostLanguage);
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setContentDetails(responseData.data);
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  },[hostLanguage])

  useEffect(()=>{
    getAllPageContent();
  },[getAllPageContent]);

  return (
    <div className="MainbBody">
      <div className="PricelistBanner MapBanner">
        <Container>
          <Row>
            <Col sm={8}>
              <h3>{contentDetails?.terms_page_data?.title}</h3>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="PricelistBody">
      <Container>
      <div dangerouslySetInnerHTML={{ __html: contentDetails?.terms_page_data?.description1}} ></div>
        </Container>
      </div>
    </div>
  );
};

export default Terms;
